const { useMemo } = require("react");
const { useSelector } = require("react-redux");
const { reactLocalStorage } = require("reactjs-localstorage");

// Memoized so callers get the same array until the user's client changes
// (a new array every render loops any effect that depends on it)
export const useClient = () => {
    const user_type = reactLocalStorage.get('user_type');
     const {  client } = useSelector((state) => state?.user);
     return useMemo(() => {
        if( ['client','facility'].includes(user_type) && client?.length>0 )
        {
            return [ client?.[0]?.value]
        }
        return []
     }, [user_type, client])
 }
// Memoized for the same reason as useClient
export const useFacility = () => {
    const user_type = reactLocalStorage.get('user_type');
     const {  facility } = useSelector((state) => state?.user);
     return useMemo(() => {
        if(  ['facility'].includes(user_type) && facility?.length>0 )
        {
            return [facility?.[0]?.value]
        }
        return []
     }, [user_type, facility])
 }